module.exports = __webpack_public_path__ + "static/img/brees-2010-slide-8.8865524.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2010-slide-8.jpg
// module id = 9wMr
// module chunks = 1